define('views/navigation/Podio.Views.SpaceNavigation',['require','jquery','lib/backbone/Backbone.PodioView','lib/Podio.UI.Modal','lib/Podio.Transport.Apps'],function(require) {

  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var Modal = require('lib/Podio.UI.Modal');
  var TransportApps = require('lib/Podio.Transport.Apps');

  return PodioView.extend({

    podioEvents : {
      'click .add-app' : 'onAddAppClicked',
      'click .show-all-apps' : 'onShowAllAppsClicked'
    },

    initialize: function() {
      this.setElement(null);
      this.elm = $('.space-navigation');

      this._ensureElement();
      this._super();
    },

    onAddAppClicked: function(elmTarget, e) {
      this.trigger('spaceNavigation:addAppTriggered');
    },

    onShowAllAppsClicked: function(elmTarget, e) {
      this.elm.toggleClass('state-all-apps');
    }

  });
});

